import { useAppContext } from 'providers/AppProvider';
import { useEffect, useState } from 'react';
import { REFRESH } from 'reducers/ConfigReducer';

const publicUrl = import.meta.env.BASE_URL.replace(/\/+$/, '');

const useToggleStyle = () => {
  const [isStylesheetLoaded, setIsStylesheetLoaded] = useState(false);
  const {
    config: { theme },
    configDispatch,
  } = useAppContext();
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  useEffect(() => {
    const ua = navigator.userAgent;
    if (/Windows/.test(ua)) {
      HTMLClassList.add('windows');
    }
    if (/Chrome/.test(ua) && !/Edge/.test(ua)) {
      HTMLClassList.add('chrome');
    }
    if (/Firefox/.test(ua)) {
      HTMLClassList.add('firefox');
    }
    if (/Safari/.test(ua) && !/Chrome/.test(ua)) {
      HTMLClassList.add('safari');
    }
    if (/Mac OS/.test(ua)) {
      HTMLClassList.add('osx');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    setIsStylesheetLoaded(false);
    Array.from(document.getElementsByClassName('theme-stylesheet')).forEach((link) => link.remove());
    const link = document.createElement('link');
    link.href = `${publicUrl}/css/theme.min.css`;
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.className = 'theme-stylesheet';

    const userLink = document.createElement('link');
    userLink.href = `${publicUrl}/css/user.min.css`;
    userLink.type = 'text/css';
    userLink.rel = 'stylesheet';
    userLink.className = 'theme-stylesheet';

    link.onload = () => {
      setIsStylesheetLoaded(true);
    };

    document.head.appendChild(link);
    document.head.appendChild(userLink);
    document.documentElement.setAttribute('dir', 'ltr');
  }, []);

  useEffect(() => {
    document.documentElement.classList[theme === 'dark' ? 'add' : 'remove']('dark');
    configDispatch({
      type: REFRESH,
    });
  }, [theme]);

  return { isStylesheetLoaded };
};

export default useToggleStyle;
